var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.value==='1'?'y':'n'},[_vm._v("\n  "+_vm._s(_vm.getText())+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }